@reference '../../../../../../styles/tailwind.css';

.editor-content {
  @apply min-h-60 px-4 pt-4 text-base leading-[1.75rem] text-pretty break-all caret-primary focus-visible:outline-hidden;

  & p {
    @apply my-4;
  }

  & h6 {
    @apply text-[1rem];
  }

  & h5 {
    @apply text-[1.15rem];
  }

  & h4 {
    @apply text-[1.3rem];
  }

  & h3 {
    @apply text-[1.45rem];
  }

  & h2 {
    @apply text-[1.6rem];
  }

  & h1 {
    @apply text-[1.75rem];
  }

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    @apply my-6 border-s-2 border-primary pl-4;
  }

  & strong {
    @apply font-[800];
  }

  & em {
    @apply font-[300] italic;
  }

  & a {
    @apply text-primary underline underline-offset-4;
  }

  & ol {
    @apply list-decimal;
  }

  & ul {
    @apply list-disc;
  }

  & ol,
  & ul {
    @apply ml-4 marker:text-primary;
  }

  & hr {
    @apply my-6 border-primary;
  }

  & blockquote {
    @apply mb-0 rounded-r-lg border-s-2 border-primary bg-primary-foreground px-4 py-2;

    & p {
      @apply my-2;
    }

    & p:first-child {
      @apply mt-0;
    }

    & p:last-child {
      @apply mb-0;
    }
  }

  & pre {
    @apply overflow-x-auto rounded-lg bg-primary-foreground p-4 text-xs;
  }

  & img {
    @apply max-w-60 min-w-20 object-contain;
  }
}
